import { createAction } from '@reduxjs/toolkit';

export const resetImprovementsValue = createAction<{
  id: string;
  fieldName: string;
}>('resetImprovementsValue');
